class CustomSelect extends HTMLElement {
  static get observedAttributes() {
    return ["selected"];
  }

  constructor() {
    super();

    this.referenceElement = document.getElementById(this.dataset.referenceId);

    // FIX: ovde je bio razmak "[ custom-select-current]"
    this.currentLabel = this.querySelector("[custom-select-current]");

    this.mainTrigger = this.querySelector("[custom-select-trigger]");

    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    const onChangeEvent = new CustomEvent("wtSelectChange", {
      detail: {
        prevValue: oldValue,
        value: newValue,
      },
    });

    this.dispatchEvent(onChangeEvent);
  }

  getFocusableElements() {
    const focusableElementsSelector = "[role='option']";

    const focusableElements = () =>
      Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
        (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  setSelectedLabel() {
    const selectedLabel = this.querySelector(
      "[custom-select-list] [selected]",
    )?.textContent?.trim();

    this.setAttribute("selected-label", selectedLabel || "");

    if (this.currentLabel) {
      this.currentLabel.textContent = selectedLabel || "";
    }
  }

  getAttrVal(attr, elem) {
    return elem && elem.hasAttribute(attr) ? elem.getAttribute(attr) : null;
  }

  unselectAll() {
    const listItems = this.querySelectorAll("[custom-select-list] li");

    listItems.forEach((item) => item.removeAttribute("selected"));
  }
  onSelect(val, elem) {
    if (!val || !elem) {
      return;
    }

    this.unselectAll();

    this.setAttribute("selected", val);
    elem.setAttribute("selected", "");

    this.setSelectedLabel();
    this.updateReferenceValue();

    this.closeState();

    setTimeout(() => {
      const url = new URL(window.location.href);

      url.searchParams.set("sort_by", val);
      url.searchParams.delete("page");

      window.location.href = url.toString();
    }, 150);
  }

  createOverlay() {
    if (!document.querySelector("[custom-select-overlay]")) {
      const overlay = document.createElement("div");

      overlay.setAttribute("custom-select-overlay", "");
      document.body.appendChild(overlay);

      overlay.addEventListener("click", () => this.closeState());
    }
  }

  handleClick(e) {
    const clickedElem = e.target;

    const closeBtn = clickedElem.closest(".wt-options__close");
    const option = clickedElem.closest("[custom-select-list] li");

    if (closeBtn) {
      e.preventDefault();
      this.closeState();
      return;
    }

    if (
      clickedElem.hasAttribute("custom-select-drawer") ||
      clickedElem === this
    ) {
      this.closeState();
      return;
    }

    if (option) {
      const value = this.getAttrVal("value", option);

      if (value) {
        this.onSelect(value, option);
      }
    }
  }

  init() {
    this.createOverlay();

    if (this.mainTrigger) {
      this.mainTrigger.addEventListener("click", () => {
        if (this.hasAttribute("open")) {
          this.closeState();
        } else {
          this.openState();
        }
      });
    }

    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";

      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.hasAttribute("open")) {
          this.closeState();
        }
      }

      if (isTabPressed && this.hasAttribute("open")) {
        if (e.shiftKey && document.activeElement === first) {
          last?.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === last) {
          first?.focus();
          e.preventDefault();
        }
      }
    });

    this.addEventListener("click", this.handleClick);

    this.setSelectedLabel();
  }

  updateReferenceValue() {
    if (!this.referenceElement) {
      return;
    }

    this.referenceElement.value = this.getAttribute("selected");

    this.referenceElement.dispatchEvent(
      new Event("input", {
        bubbles: true,
        cancelable: true,
      })
    );

    this.referenceElement.dispatchEvent(
      new Event("change", {
        bubbles: true,
        cancelable: true,
      })
    );
  }

  openState() {
    const body = document.body;
    const openBodyAttr = "custom-select-opened";
    const header = document.querySelector("header.page-header");
    const liItems = this.querySelectorAll("li");
    const trigger = this.querySelector("[custom-select-trigger]");
    const selectedItem = this.querySelector("[custom-select-list] [selected]");

    this.setAttribute("open", "");
    body.setAttribute(openBodyAttr, "");

    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
    }

    if (body.classList.contains("page-header-sticky") && header) {
      header.classList.add("hide");
    }

    for (const item of liItems) {
      item.setAttribute("tabindex", "0");
    }

    if (selectedItem) {
      selectedItem.focus();
    }
  }

  closeState() {
    const body = document.body;
    const openBodyAttr = "custom-select-opened";
    const header = document.querySelector("header.page-header");
    const liItems = this.querySelectorAll("li");
    const trigger = this.querySelector("[custom-select-trigger]");

    this.removeAttribute("open");
    body.removeAttribute(openBodyAttr);

    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    }

    if (body.classList.contains("page-header-sticky") && header) {
      header.classList.remove("hide");
    }

    for (const item of liItems) {
      item.setAttribute("tabindex", "-1");
    }

    if (this.mainTrigger) {
      this.mainTrigger.focus();
    }
  }

  toggleState() {
    if (this.hasAttribute("open")) {
      this.closeState();
    } else {
      this.openState();
    }
  }
}

customElements.define("custom-select", CustomSelect);